import ActiveInventoryApi from '../../../apis/active-inventory'
import { ActiveInventoryItem } from '../../../schema/contract'
import { PropertyExampleListItem } from './property-example-list-item'

const ActiveInventoryList = (props: {
  contractId: string
  list: ActiveInventoryItem[]
  isOwner: boolean
  reFetch: () => void
  isVertical?: boolean
  onItemClick?: (item: ActiveInventoryItem) => void
  currentVisibleItem?: ActiveInventoryItem | null
  isMobile?: boolean
  selectedItemId?: string
  background?: 'gray' | 'white'
}) => {
  const itemsToRender =
    props.isMobile && props.currentVisibleItem
      ? [props.currentVisibleItem]
      : props.list

  return (
    <>
      {itemsToRender.map((item) => {
        const originalIndex = props.list.findIndex(
          (listItem) => listItem.id === item.id
        )
        const isSelected = props.selectedItemId === `marker-${originalIndex}`
        return (
          <PropertyExampleListItem
            key={`contract-${originalIndex}`}
            item={item}
            isVisibleToggle={!props.isOwner}
            onChangeToggle={async (e) => {
              await ActiveInventoryApi.updateActiveInventoryVisibility(
                item.id,
                props.contractId,
                e.target.checked
              )
              props.reFetch()
            }}
            isVertical={props.isVertical}
            onClick={props.onItemClick && (() => props.onItemClick?.(item))}
            isSelected={isSelected}
            noSelectedMode={props.isMobile || false}
            background={props.background || 'gray'}
          />
        )
      })}
    </>
  )
}

export default ActiveInventoryList
